import React from "react";
import { NavLink } from "react-router-dom";
const MenuBar = () => {
  return (
    <div className="header-wrapper">
      <header>
        <div className="header-logo">Journey</div>
        <div className="header-search">
          <input type="text" placeholder="Search" />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            fill="none"
            viewBox="0 0 21 21"
          >
            <circle
              cx="10.296"
              cy="10.296"
              r="7.865"
              stroke="#200E32"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
            <path
              stroke="#200E32"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="m15.766 16.174 3.083 3.076"
              opacity=".4"
            />
          </svg>
        </div>

        <nav>
          <ul>
           
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="none"
                  viewBox="0 0 28 28"
                  className="menuIconMain"
                >
                  <path
                    stroke="#171717"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    className="menuIconChild"
                    d="M10.683 24.233v-3.578c0-.91.742-1.649 1.662-1.655h3.367c.923 0 1.672.741 1.672 1.655v3.59a1.43 1.43 0 0 0 1.403 1.422h2.245c2.237 0 4.051-1.796 4.051-4.012v0-10.178a2.846 2.846 0 0 0-1.122-2.222l-7.677-6.122a3.71 3.71 0 0 0-4.602 0L4.04 9.266c-.7.53-1.114 1.35-1.122 2.223v10.166c0 2.216 1.814 4.012 4.051 4.012h2.245c.8 0 1.448-.642 1.448-1.434v0"
                  />
                </svg>
              </NavLink>
   
            <NavLink
                to="/addstory"
                className={({ isActive }) => (isActive ? "active" : "")}
              > 
                 <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="none"
                viewBox="0 0 28 28"
                className="menuIconMain"
              >
                <path
                  stroke="#171717"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  className="menuIconChild"
                  d="M19.843 1.806H8.91c-3.811 0-6.2 2.698-6.2 6.516v10.302c0 3.818 2.377 6.516 6.2 6.516h10.933c3.822 0 6.2-2.698 6.2-6.516V8.322c0-3.818-2.378-6.516-6.2-6.516Z"
                  clipRule="evenodd"
                />
                <path
                  fill="#171717"
                  d="M15.126 9.188a.75.75 0 0 0-1.5 0v3.524H10.1a.75.75 0 0 0 0 1.5h3.527v3.524a.75.75 0 0 0 1.5 0v-3.524h3.528a.75.75 0 1 0 0-1.5h-3.528V9.188Z"
                  clipRule="evenodd"
                  opacity=".4"
                  className="menuIconChildSemi"
                />
              </svg>
              </NavLink>
           
      
              <NavLink
                to="/explore"
                className={({ isActive }) => (isActive ? "active" : "")}
              > 
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="none"
                viewBox="0 0 28 28"
                className="menuIconMain"
              >
                <circle
                  cx="13.546"
                  cy="13.546"
                  r="11.213"
                  stroke="#171717"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  className="menuIconChild"
                />
                <path
                  stroke="#171717"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="m9.648 17.444 1.859-5.937 5.937-1.859-1.858 5.938-5.938 1.858Z"
                  clipRule="evenodd"
                  opacity=".4"
                  className="menuIconChildSemi"
                />
              </svg>
              </NavLink>
              <NavLink
                to="/notifications"
                className={({ isActive }) => (isActive ? "active" : "")}
              > 
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                fill="none"
                viewBox="0 0 28 28"
                className="menuIconMain"
              >
                <path
                  stroke="#171717"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M13.707 24.33a42.572 42.572 0 0 1-7.396-5.47 13.91 13.91 0 0 1-3.52-5.332c-1.32-3.903.223-8.37 4.542-9.693a7.657 7.657 0 0 1 6.662 1.067 7.669 7.669 0 0 1 6.662-1.067c4.32 1.323 5.874 5.79 4.553 9.693a13.91 13.91 0 0 1-3.52 5.331 42.569 42.569 0 0 1-7.395 5.47l-.289.171-.3-.17Z"
                  clipRule="evenodd"
                  className="menuIconChild"
                />
                <path
                  stroke="#171717"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M18.592 8.229c1.308.397 2.238 1.512 2.354 2.825"
                  opacity=".4"
                  className="menuIconChildSemi"
                />
              </svg>
              </NavLink>
          </ul>
          <div className="Profile">
            <img src="./images/dummyProfile.jpg" alt="profile" />
          </div>
        </nav>
      </header>
    </div>
  );
};

export default MenuBar;
